module.exports = __webpack_public_path__ + "assets/img/bg-ea1a30a6.jpg";